<template>
  <div>
    <v-row class="mt-4" no-gutters>
      <v-col>
        <v-card
          v-for="(session, index) in filteredPresentations"
          :key="session.codigo"
          elevation="0"
          style="border-radius: 0px"
          width="100%"
          class="pa-5"
          :style="getStyleCard(index)"
          @click="handleSelectEvent(session)"
          :disabled="session.status_venda === 'esgotada'"
        >
          <v-row no-gutters align="center">
            <v-col>
              <v-row no-gutters>
                <span class="date">
                  {{
                    firstLetterUppercase(
                      $moment(session.data).format("dddd").replace("-feira", "")
                    )
                  }}</span
                >
              </v-row>
              <v-row no-gutters>
                <span class="hour">{{
                  $moment(getFormattedDate(session)).format("DD/MMM - HH:mm")
                }}</span>
              </v-row>
            </v-col>

            <v-spacer></v-spacer>
            <v-chip
              v-if="session.status_venda === 'esgotada'"
              outlined
              color="#838D9B"
              >Esgotado</v-chip
            >
            <v-icon v-else>mdi-chevron-right</v-icon>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["filteredPresentations"],
  computed: {
    ...mapGetters(["eventDetails"]),
  },

  methods: {
    firstLetterUppercase(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },

    handleSelectEvent(session) {
      this.$store.commit("SET_ERROR_PRODUCTS", null);
      this.$router.push({ params: { event: session.codigo } });
      this.eventDetails.codigo = session.codigo;
      this.$store.commit("SET_LOADING", true);
    },

    getStyleCard(index) {
      let style =
        "border-bottom: 1px solid #eaeaea; border-left: 1px solid #eaeaea; border-right: 1px solid #eaeaea;";
      let filteredSessions = this.eventDetails.relacionados;

      if (index === 0)
        style +=
          "border-top-right-radius: 10px; border-top-left-radius: 10px; border-top: 1px solid #eaeaea;";

      if (index === filteredSessions.length - 1)
        style +=
          "border-bottom-right-radius: 10px; border-bottom-left-radius: 10px;";

      return style;
    },

    getFormattedDate(presentation) {
      let splittedDate = `${presentation.data.split(" ")[0]} ${
        presentation.horario_evento
      }:00`;

      return splittedDate;
    },
  },
};
</script>

<style scoped>
.date {
  font-weight: 500;
}

.hour {
  font-weight: 500;
  font-size: 12px;
}
</style>
